export default __webpack_public_path__ + "static/media/ri_alarm-warning-line.01b65536.svg";